import React from "react";
import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const HelpSvg = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='1em' height='1em' viewBox='0 0 25 25' fill='none'>
    <path
      d='M12.9531 22.0312C18.476 22.0312 22.9531 17.5541 22.9531 12.0312C22.9531 6.5084 18.476 2.03125 12.9531 2.03125C7.43028 2.03125 2.95312 6.5084 2.95312 12.0312C2.95312 17.5541 7.43028 22.0312 12.9531 22.0312Z'
      stroke='url(#paint0_linear_9757_9298)'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M10.0431 9.03124C10.2782 8.36291 10.7423 7.79935 11.3531 7.44037C11.9639 7.0814 12.682 6.95018 13.3803 7.06995C14.0786 7.18973 14.7119 7.55276 15.1682 8.09477C15.6245 8.63677 15.8742 9.32276 15.8731 10.0312C15.8731 12.0312 12.8731 13.0312 12.8731 13.0312'
      stroke='url(#paint1_linear_9757_9298)'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M12.9531 17.0312H12.9631'
      stroke='url(#paint2_linear_9757_9298)'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <defs>
      <linearGradient
        id='paint0_linear_9757_9298'
        x1='2.95312'
        y1='2.03125'
        x2='23.6859'
        y2='2.82214'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FE901F' />
        <stop offset='1' stopColor='#A94AC7' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_9757_9298'
        x1='10.0431'
        y1='7.02676'
        x2='16.0872'
        y2='7.25063'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FE901F' />
        <stop offset='1' stopColor='#A94AC7' />
      </linearGradient>
      <linearGradient
        id='paint2_linear_9757_9298'
        x1='12.9531'
        y1='17.0312'
        x2='12.9635'
        y2='17.0313'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FE901F' />
        <stop offset='1' stopColor='#A94AC7' />
      </linearGradient>
    </defs>
  </svg>
);

export const HelpColorIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={HelpSvg} {...props} />
);
